import {
  TextField,
  Paper,
  Typography,
  Box,
  Grid,
  Link, SvgIcon
} from "@mui/material";
import axios from "axios";
import config from "../../services/configration/config";

import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import InputAdornment from "@mui/material/InputAdornment";
import { ApiType } from "../../services/ApiTags";
import { getFromLocalStorage, saveToLocalStorage } from "../../utils/localStorageUtils";
import { ACCESS_TOKKEN, BASIC_AUTH_TOKKEN, LOGIN_ID, MESSAGE_KEY } from "../../constants/LocalStorageKeyValuePairString";
import useAxiosHook from "../../hooks/UseAxios";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_CONFIGRATION_PLEASE_WAIT,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  SUCCESS,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import DebugLog from "../../utils/DebugLog";
import { Navigate, useNavigate } from "react-router-dom";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import { SnackbarProvider, useSnackbar } from "notistack";
import { collapseMenu, isAuthPageAtom, sessionIdStatus, showErrorAlertDialog, showSuccessAlertDialog } from "../../config/AppConfig";
import { useAtom } from "jotai";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import ConnectionStatus from "../../utils/ConnectionStatus";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import { generateBasicAuthHeader } from "../../services/BasicAuthHashing";
import { LOGIN } from "../../constants/Constant";
import ShowSuccessDialog from "../../components/ShowSuccessDialog";

const ForgotPassword = () => {

  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [success, setSuccess] = useState("");
  const [, setError] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const [loading, setLoading] = useState(false);
  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [getProgressbarText, setProgressbarText] = useState("");
  const [getSuccessDialogStatus, setSuccessDialog] = useAtom(showSuccessAlertDialog);


  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { data, error, showProgressBar, fetchData } = useAxiosHook();
  const [,setSessionIdState] = useAtom(sessionIdStatus);
  const [, setIsCollapsed] = useAtom(collapseMenu);
  const [, setAuthStatus] = useAtom(isAuthPageAtom);

  useEffect(() => {
    setIsCollapsed(true);
    setSessionIdState("");
    setAuthStatus(true);
    getNewConfigration();
    // DebugLog(JSON.stringify({ dataProps }));
  }, [isNetworkConnectionAvailable, enqueueSnackbar, Navigate]);

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(LOADING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);


  useEffect(() => {
    if (error) {
      if (
        error.data != null &&
        error.data.responseCode != null &&
        error.data.responseCode != -1
      ) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      } else {
        const message =
          error.data != null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }, [error]);


  const getNewConfigration = () => {
    requestAuthToken(false)
     // requestBasicAuth();
  };

  // Generate oAuth token 
      const requestAuthToken = async (isLoginApiCallRequired) => {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_CONFIGRATION_PLEASE_WAIT);
  
      const tokenApiKey = process.env.REACT_APP_O_AUTH_TOKKEN_API_KEY;
      const formData = new URLSearchParams();
      formData.append("client_id", process.env.REACT_APP_O_AUTH_CLIENT_ID);
      formData.append("client_secret",  process.env.REACT_APP_O_AUTH_CLIENT_SECRET);
      formData.append("grant_type", process.env.REACT_APP_O_AUTH_GRANT_TYPE);
  
        try {
          const response = await axios.post(config.oAuthBaseUrl+process.env.REACT_APP_O_AUTH_TOKEN_API_URL, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              apikey: tokenApiKey,
            },
          });
      
          console.log("Response:", response.data);
          saveToLocalStorage(ACCESS_TOKKEN, response.data.access_token);
  
          // if (isLoginApiCallRequired) {
          //   saveToLocalStorage(LOGIN_ID, email);
          //   doSignUp(email, password);
          // }
        } catch (error) {
          console.error("Error:", error);
        }
      };
    };

  // Generate Basic Auth hHeader()
  const requestBasicAuth = () => {
    if (isNetworkConnectionAvailable) {

      const headerTokken = generateBasicAuthHeader();
      const authToken = "BASIC " + headerTokken;

      fetchData(
        process.env.REACT_APP_BASIC_AUTH_API_URL,
        ApiType.BASIC_AUTH,
        ApiType.GET_METHOD,
        null,
        {
          headers: {
            Authorization: authToken,
          },
        },
        (data) => {
          saveToLocalStorage(MESSAGE_KEY, data.messageKey);
          saveToLocalStorage(BASIC_AUTH_TOKKEN, data.basicAuthToken);

        }
      );
    }
  };


  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  function callForgotPasswordApi(email) {
    try {
      if (isNetworkConnectionAvailable) {
        //  loginId: String value of the login Id

        const requestObject = {
          loginId: email,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CHANGE_PASSWORD
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_FORGOT_PASSWORD_API_URL,
            ApiType.FORGOT_PASSWORD,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                 setLoading(false);
                 showSuccessAlert(SUCCESS, "We've sent you an email with instructions to reset your password. Please follow the instructions to complete the process. Thank you");
             
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function showSuccessAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setSuccessDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
      if (email!==null && email!=="") {
      saveToLocalStorage(LOGIN_ID,email)
      setErrorMsg("");
      setSuccess(
        "If entered user id is correct, you will receive a password reset link on registered email id."
      );
      callForgotPasswordApi(email);
    } else {
      setErrorMsg("Please enter a valid email address.");
      setSuccess("");
    }
  };

  function onConfirmButtonResponseReceived(){
    navigate(LOGIN);
  }
  return (
    <Box>
    <SnackbarProvider maxSnack={3}>
      <ConnectionStatus />

      <ShowSuccessDialog
          status={getSuccessDialogStatus}
          title={title}
          content={content}
          onConfirmButtonClick={onConfirmButtonResponseReceived}
        />

      <ShowErrorAlertDialog
        status={getDialogStatus}
        title={title}
        content={content}
      />
      {isNetworkConnectionAvailable ? (
        <CustomProgressDialog open={loading} text={getProgressbarText} />
      ) : (
        showNoInternetSnackBar()
      )}

    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        width: "125% !important",
        position: "absolute",
        left: "-25%",
      }}
    >
      {/* BG */}

      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItems="center"
        xs={12}
        sx={{
          backgroundImage: "url(/assets/login/Login-BG-2.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        <Grid
          container
          direction={"row"}
          p={3}
          justifyContent="space-around"
          alignItems={"center"}
          xs={8.8}
        >
          <Grid item xs={12} sm={5} md={4} lg={5} xl={6} pb={5}>
            <Box display="flex" alignItems="center">
              <img src="assets/common/Logo-White.svg" width={320} />
            </Box>
          </Grid>

          {/* Login Container */}
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            lg={5}
            xl={6}
            component={Paper}
            elevation={12}
            sx={{
              borderRadius: 3,
              border: "1px solid #E4EBF7",
              padding: "0",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                width:"100%",
                py: 6,
                px: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                color={colors.grey[100]}
                fontWeight="bold"
                sx={{ m: "0 0 15px 0px", fontSize: 24 }}
              >
                Forgot Password
              </Typography>

              <Typography
                width={"90%"}
                variant="h6"
                color={colors.grey[100]}
                sx={{ textAlign:"center", m: "0 0 15px 0px", color:"#888", fontWeight:"500", fontSize: "16px" }}
              >
              Don't worry ! We'll send you an email with instruction to reset your password.
              </Typography>

              {/* Form Elements */}
              <Box sx={{ width:"100%", padding: "0 5%" }}>

                  <Box component="form" onSubmit={handleSubmit}>

                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="email"
                      label="Login Id"
                      type="text"
                      id="email"
                      autoFocus
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      sx={{ gridColumn: "span 2" }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box sx={{ margin: "0 8px" }}>
                              <SvgIcon>
                                <svg
                                  width="15"
                                  height="19"
                                  viewBox="0 0 15 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.7509 18.2637C13.9791 18.2637 14.1613 18.024 14.1477 17.7392C13.9906 14.5454 12.4095 11.8316 10.187 10.5747C9.32857 10.0811 8.36338 9.82348 7.38266 9.82619C6.40194 9.82891 5.43808 10.0919 4.58216 10.5902C2.37395 11.8541 0.805641 14.5588 0.649217 17.7392C0.634997 18.0212 0.817153 18.2637 1.04536 18.2637H13.7509Z"
                                    stroke="#2F3BF5"
                                    strokeWidth="1.17"
                                    strokeMiterlimit="10"
                                  />
                                  <path
                                    d="M7.39844 10.6699C9.72839 10.6699 11.6172 8.59224 11.6172 6.0293C11.6172 3.46635 9.72839 1.38867 7.39844 1.38867C5.06849 1.38867 3.17969 3.46635 3.17969 6.0293C3.17969 8.59224 5.06849 10.6699 7.39844 10.6699Z"
                                    fill="white"
                                    stroke="#FF0084"
                                    strokeWidth="1.17"
                                    strokeMiterlimit="10"
                                  />
                                </svg>
                              </SvgIcon>
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {errorMsg && (
                      <Typography color="error" variant="body2">
                        {errorMsg}
                      </Typography>
                    )}
                    {success && (
                      <Typography color="primary" variant="body2">
                        {success}
                      </Typography>
                    )}


                    <Box sx={{ mt: 2 }}>
                        <CustomButton
                          // btnBG = "#FFF"
                          // btnColor="#000"
                          btnTxt="Reset Password"
                          // onClick = {navigate(CONSTANT.LOGIN)}
                          type="submit"
                        ></CustomButton>
                        <Grid container justifyContent={"center"}>
                          <Grid item mt={2}>
                            <Link
                              href="/"
                              variant="body2"
                              sx={{
                                textDecoration: "none",
                                fontWeight: "500",
                                fontSize: "0.75rem",
                              }}
                            >
                              Go Back
                            </Link>
                          </Grid>
                          </Grid>
                    </Box>

                </Box>

              </Box>
              
            </Box>
            {/* Header */}
            
            <Box sx={{ position: "absolute", bottom: "0", right: "2%" }}>
              <Typography
                variant="h5"
                color={colors.grey[900]}
                fontWeight="400"
                sx={{ m: "0 0 15px 0px", fontSize: 16 }}
              >
                2024 © YTLC. All Rights Reserved.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {/* BG */}
    </Grid>
    
     </SnackbarProvider>
     </Box>
  );
};

export default ForgotPassword;
